import { Injectable } from '@angular/core';
import { DefaultCoursesQuestionsService } from './default-courses-questions.service';
import { QuestionBase, NumberQuestion, QuestionGroup, CheckboxQuestion } from 'core/components/forms';
import { PublishQuestion } from 'core/components/forms/publish-question';
import { ProfileService } from 'core/services/profile.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AdminCoursesQuestionsService extends DefaultCoursesQuestionsService {
  constructor(protected translateService: TranslateService, protected profileService: ProfileService) {
    super(translateService, profileService);
  }
  createSpecificQuestions(params: any = {}): QuestionBase<any>[] {
    return [this.getCourseConfigGroup(params), this.getCourseMeta(params)];
  }

  public getCourseConfigGroup(params: any = {}): QuestionGroup {
    const childQuestions = [
      this.getCreditsQuestion(params),
      this.getBonusPossibleQuestion(params),
      this.getDiplomaQuestion(params),
      this.getClientsAccessQuestion(params),
      this.getDemoQuestion(params),
      this.getAccessModeQuestion({
        ...params,
        disabledQuestion: !this.profileService.canExecute('courses.changeAccessMode')
      })
    ]
      .filter((question) => question != null)
      .sort((a, b) => a.order - b.order);

    const courseConfigGroup: QuestionGroup = new QuestionGroup({
      key: 'courseConfigIds',
      title: 'courses.config.title',
      isSection: true,
      isDropdown: false,
      isOpenCollapsible: false,
      hasHtml: true,
      childQuestions
    });

    return courseConfigGroup;
  }

  public getBonusPossibleQuestion(params: any = {}): QuestionBase<any> {
    const { course, clientDetail } = params;

    return clientDetail
      ? null
      : new CheckboxQuestion({
          key: 'bonusPossible',
          label: 'courses.config.bonusPossible',
          class: 'col-2-offset',
          disabled: false,
          value: course && !course.bonusPossible ? false : course.bonusPossible,
          order: 7
        });
  }

  public getCreditsQuestion(params: any = {}): QuestionBase<any> {
    const { course, clientDetail } = params;

    return course.type === 'game' && !clientDetail
      ? new NumberQuestion({
          key: 'credits',
          label: 'courses.config.credits',
          class: 'col-4-offset',
          value: Number(course.credits),
          validators: { number: true },
          order: 1
        })
      : null;
  }

  public getClientsAccessQuestion(params: any = {}): QuestionBase<any> {
    const { course, clientDetail } = params;

    return clientDetail
      ? null
      : new PublishQuestion({
          key: 'publish',
          label: 'courses.config.clientsWithAccess',
          class: 'col-2-offset',
          value: course.publish,
          owner: course.clientName,
          courseId: course.id,
          selector: true,
          order: 2
        });
  }

  public getDemoQuestion(params: any = {}): QuestionBase<any> {
    const { course, clientDetail } = params;

    return !clientDetail
      ? new CheckboxQuestion({
          key: 'demoEnabled',
          label: 'courses.config.demoEnabledAccess',
          class: 'col-2-offset',
          value:
            !course || !course.configuration || !course.configuration.demoEnabled
              ? false
              : course.configuration.demoEnabled,
          order: 8
        })
      : null;
  }
}
